// @flow
import React, { useContext } from 'react';

import appConfig from 'Config';
import ReactAppContext from 'Context/ReactAppContext';
import { isSeller } from 'Utils/seller/sellerUtils';

export const Cedexis = () => {
  const appContext = useContext(ReactAppContext);
  const performance = appConfig.get('performance');

  if (!isSeller(appContext) && performance.cedexis.enabled) {
    return (
      <script
        dangerouslySetInnerHTML={{
          __html: `
            (function(e,c,a,g,f){function d(){var b=c.createElement("script");b.async=!0;
              b.src="//radar.cedexis.com/1/10015/radar.js";c.body.appendChild(b)}
              (function(){for(var b=[/\bMSIE (5|6)/i],a=b.length;a--;)if(b[a]
                .test(navigator.userAgent))return!1;return!0})()
              &&("complete"!==c.readyState?(a=e[a])?a(f,d,!1):(a=e[g])&&a("on"+f,d):d())})
            (window,document,"addEventListener","attachEvent","load");
        `,
        }}
      />
    );
  }

  return null;
};
